// extracted by mini-css-extract-plugin
export default {"list":"ContactList_list__3daws","btn":"ContactList_btn__QQhmE"};